import { Pipe, PipeTransform } from '@angular/core';

/**
 * Display-only mapping for Time Period labels.
 * Renames the time-period token "Year" to "Calendar Year" for presentation
 * without altering the underlying data value used for
 * selection/matching/sorting logic.
 *
 * The mapping is token-scoped: it only rewrites a segment that, when trimmed,
 * is exactly "Year". Composite values (e.g. "Year|2024", "Year : 2024",
 * "Time Period : Year : 2025") are split on their delimiters so that only the
 * standalone time-period token is renamed. Values such as "1 Year", "12MMA",
 * brand/category names or an already-mapped "Calendar Year" are left untouched,
 * and the transform is idempotent.
 */
export function mapCalendarYearLabel(value: string): string {
  if (value == null) {
    return value;
  }
  // Split while keeping the delimiters so the string can be re-joined exactly.
  return value
    .split(/(\s*(?:&nbsp;|[|:,@])\s*)/)
    .map((segment) =>
      segment.trim() === 'Year' ? segment.replace('Year', 'Calendar Year') : segment
    )
    .join('');
}

@Pipe({
  name: 'timePeriodLabel'
})
export class TimePeriodLabelPipe implements PipeTransform {
  transform(value: string): string {
    return mapCalendarYearLabel(value);
  }
}
